import ExpandedSideBar from '@/components/sideBar/ExpandedSideBar.vue'
import CompactSideBar from '@/components/sideBar/CompactSideBar.vue'
import { billingSidebarOptions } from '@/modules/billing-module/components/sidebar/billing-sidebar-options'
import { Nullable, StrictNullable } from '@/shared/types/app.types'
import { SidebarTimeFilterType } from '@/components/sideBar/filters/time-filter/sidebar-filters-time-filter.model'
import { UIComponentCustomFilterResponse } from '@/api/services/common/ui-component/custom-filter/ui-component-custom-filter.dto'
import {
    BillingCategory,
    BillingGridType
} from '@/modules/billing-module/components/grid/config/datasources/billing-grid-datasource-factory'
import { VtCustomFilter } from '@/api/resources/common/shared/models/common.models'
import { findNodeByPropertyValue } from '@/components/sideBar/sideBarUtils'

export interface BillingCustomFilter extends VtCustomFilter {
    gridType: BillingGridType
    category: BillingCategory
    timeFilter: SidebarTimeFilterType,
    operations: string[]
}

export interface CustomFilterRenamed extends UIComponentCustomFilterResponse<BillingCustomFilter> {
    label: string
}

export interface BillingSidebarState {
    componentCode: string
    sidebars: any[]
    sidebar: any
    defaultOption: StrictNullable<any>
    options: any
    customFilterOptions: UIComponentCustomFilterResponse<BillingCustomFilter>[]
}
export const initialBillingSidebarState =
    (): BillingSidebarState => ({
        componentCode: 'uicomponent.billing.sidepanel',
        sidebars: [ ExpandedSideBar, CompactSideBar ],
        sidebar: ExpandedSideBar,
        defaultOption: null,
        options: billingSidebarOptions(),
        customFilterOptions: []
    })

export const initialTimeFilter = SidebarTimeFilterType.THIS_WEEK

export const billingCompleteArray: any[] =
    billingSidebarOptions().expanded.reduce(
        (prev: any, next: any) => next.children
            ? prev.concat(next.children)
            : prev.concat(next), [])

const firstVisibleSidebarOption = (): Nullable<string> => {
    const firstChild: any = billingSidebarOptions().expanded[0].children.find(option => !option.hide)
    return firstChild?.children[0]?.id
}

export const initialBillingSelectedOption: any =
    findNodeByPropertyValue('id', firstVisibleSidebarOption(), billingCompleteArray)
